/*
 * @Copyright 2023-2026. Institute for Future Intelligence, Inc.
 */

import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useStore } from './stores/common';
import * as Selector from './stores/selector';
import { useTranslation } from 'react-i18next';

const BASE = import.meta.env.BASE_URL || '/';
const TERMS_URL = BASE + 'terms';
const PRIVACY_URL = BASE + 'privacy';

const AcceptCookie = React.memo(() => {
  const language = useStore(Selector.language);
  const lang = { lng: language };
  const { t } = useTranslation();

  const linkStyle: React.CSSProperties = {
    color: '#7eb6ff',
    textDecoration: 'underline',
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('cookie.Accept', lang)}
      cookieName="AIMSCookieName"
      style={{ background: '#2B373B', textAlign: 'center', zIndex: 99999 }}
      buttonStyle={{ color: '#4e503b', fontSize: '12px' }}
      expires={150}
    >
      {t('cookie.Statement', lang)} {t('cookie.AgreementPrefix', lang)}{' '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {t('aboutUs.TermsOfService', lang)}
      </a>{' '}
      {t('cookie.AgreementConnector', lang)}{' '}
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
        {t('aboutUs.PrivacyPolicy', lang)}
      </a>
      {t('cookie.AgreementSuffix', lang)}
    </CookieConsent>
  );
});

export default AcceptCookie;
